import React from "react";

import Image from "next/image";

import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Typography,
} from "@mui/material";

import BackgroundImage from "../../../public/static/home/role_bg_frag2.png";

const HomeRoles = (props) => (
  <Box
    sx={{
      position: "relative",
    }}
    {...props}
  >
    <Box
      sx={(theme) => ({
        backgroundImage: "url('/static/home/role_bg_frag1.svg')",
        backgroundPosition: "center",
        backgroundRepeat: "repeat-y",
        backgroundSize: "cover",
        left: 0,
        height: theme.spacing(32),
        position: "absolute",
        top: 0,
        width: "100%",
      })}
    />
    <Container maxWidth="md" sx={{ position: "relative" }}>
      <Box
        sx={(theme) => ({
          height: theme.spacing(32),
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%",
        })}
      >
        <Image alt="" src={BackgroundImage} layout="fill" objectFit="cover" />
      </Box>
    </Container>
    <Box
      sx={(theme) => ({
        backgroundImage: "url('/static/home/role_bg_frag3.svg')",
        backgroundPosition: "top left",
        backgroundRepeat: "repeat",
        backgroundSize: "auto 16.67%",
        display: { xs: "none", lg: "block" },
        height: theme.spacing(32),
        position: "absolute",
        right: 0,
        top: 0,
        width: { lg: "20%", xl: "35%" },
      })}
    />
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
      <Box sx={{ pt: 4, pb: { xs: 16, sm: 8 } }}>
        <Typography variant="h1" color="primary.contrastText">
          合作
        </Typography>
      </Box>
      <Box
        sx={{
          alignItems: { xs: "center", sm: "stretch" },
          display: "flex",
          px: { xs: 2, md: 10 },
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            alignItems: "center",
            backgroundColor: "background.default",
            border: "1px #aa9b88 solid",
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            maxWidth: "360px",
            mx: { xs: 0, sm: 2, md: 4 },
            my: { xs: 2, sm: 4 },
            overflow: "visible",
            p: 2,
            position: "relative",
            width: { xs: "100%", sm: "50%" },
            "&::before": {
              content: '""',
              position: "absolute",
              height: "100%",
              width: "100%",
              top: 0,
              border: "7px #aa9b88 solid",
            },
            "&::after": {
              content: '""',
              pointerEvents: "none",
              position: "absolute",
              height: "100%",
              width: "100%",
              top: 0,
              border: "6px #c9b091 solid",
            },
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              p: 2,
              width: "100%",
              "&::after": {
                content: "url(/static/home/role_illus_business.png)",
                position: "absolute",
                bottom: -10,
                left: 0,
                transform: "translate(-50%,0)",
                zIndex: 1,
              },
            }}
          >
            <Typography
              align="center"
              color="textSecondary"
              sx={{ pb: 6, pt: 2 }}
              variant="h5"
            >
              希望與更多優秀的創作者合作
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
              sx={{
                mb: 2,
              }}
            >
              我想
            </Typography>
            <Button
              href="/business/contact-sales"
              disableElevation
              color="action"
              size="large"
              variant="contained"
              sx={{ mb: 4 }}
            >
              成為委託人
            </Button>
          </Box>
        </Card>
        <Card
          sx={{
            alignItems: "center",
            backgroundColor: "background.default",
            border: "1px #aa9b88 solid",
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            maxWidth: "360px",
            mx: { xs: 0, sm: 2, md: 4 },
            my: { xs: 2, sm: 4 },
            overflow: "visible",
            p: 2,
            position: "relative",
            width: { xs: "100%", sm: "50%" },
            "&::before": {
              content: '""',
              position: "absolute",
              height: "100%",
              width: "100%",
              top: 0,
              border: "7px #aa9b88 solid",
            },
            "&::after": {
              content: '""',
              pointerEvents: "none",
              position: "absolute",
              height: "100%",
              width: "100%",
              top: 0,
              border: "6px #c9b091 solid",
            },
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              p: 2,
              width: "100%",
              "&::after": {
                content: "url(/static/home/role_illus_creator.png)",
                position: "absolute",
                bottom: -20,
                left: 0,
                transform: "translate(-50%,0)",
                zIndex: 1,
              },
            }}
          >
            <Typography
              align="center"
              color="textSecondary"
              sx={{ pb: 6, pt: 2 }}
              variant="h5"
            >
              希望在各企劃中施展所長
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
              sx={{
                mb: 2,
              }}
            >
              我想
            </Typography>
            <Button
              href="/creator/join-us"
              disableElevation
              color="action"
              size="large"
              variant="contained"
              sx={{ mb: 4 }}
            >
              成為創作者
            </Button>
          </Box>
        </Card>
      </Box>
      <Divider sx={{ pt: 8 }} />
    </Container>
  </Box>
);

export default HomeRoles;
